import React, { useState, useCallback, useMemo } from 'react';
import { StepOne, StepTwo, StepThree, StepFour } from '../..';
import { Button } from '../../formControls/Button/Button';
import styles from './index.module.css';

const QuickSchedule = ({
  handleSave,
  rideRequestFields,
  handleQuickSubmit,
  platformPreferences,
  rideOptions,
  defaultTimeZone,
  showCovidField,
  syncFormikValues,
  handleShowDetailView,
  costCenterField,
  riderDetails,
  showAdditionalSourceField,
  showDocumentReasonForRideField,
  ...rest
}) => {
  const [stepOneValues, setStepOneValues] = useState({});
  const [stepTwoValues, setStepTwoValues] = useState({});
  const [stepThreeValues, setStepThreeValues] = useState({});
  const [stepFourValues, setStepFourValues] = useState({});

  const [stepOneValid, setStepOneValid] = useState(false);
  const [stepTwoValid, setStepTwoValid] = useState(false);
  const [stepThreeValid, setStepThreeValid] = useState(false);
  const [stepFourValid, setStepFourValid] = useState(false);

  const hideStepFour = useMemo(() => (
    !costCenterField?.show &&
    !showAdditionalSourceField?.show &&
    !showDocumentReasonForRideField?.show
  ), [costCenterField, showAdditionalSourceField, showDocumentReasonForRideField]);

  const handleStepFormikValues = useCallback((stepSetter, stepKey) => (values) => {
    stepSetter(values);
    const combined = {
      step1: stepKey === 'stepOne' ? values : stepOneValues,
      step2: stepKey === 'stepTwo' ? values : stepTwoValues,
      step3: stepKey === 'stepThree' ? values : stepThreeValues,
      step4: stepKey === 'stepFour' ? values : stepFourValues,
    };
    syncFormikValues?.(combined);
  }, [stepOneValues, stepTwoValues, stepThreeValues, stepFourValues, syncFormikValues]);

  const handleStepValid = useCallback((stepKey, isValid) => {
    const setters = {
      stepOne: setStepOneValid,
      stepTwo: setStepTwoValid,
      stepThree: setStepThreeValid,
      stepFour: setStepFourValid,
    };
    setters[stepKey]?.(isValid);
  }, []);

  const save = useCallback(() => {
    const combined = {
      step1: stepOneValues,
      step2: stepTwoValues,
      step3: stepThreeValues,
      step4: stepFourValues,
    };
    syncFormikValues?.(combined);
    handleQuickSubmit(combined, 'quickSchedule');
    window.scrollTo(0, 0);
   
  }, [stepOneValues, stepTwoValues, stepThreeValues, stepFourValues, handleQuickSubmit, handleShowDetailView, syncFormikValues]);


const  swtichToDetailView = useCallback(() => {
    const combined = {
      step1: stepOneValues,
      step2: stepTwoValues,
      step3: stepThreeValues,
      step4: stepFourValues,
    };
    syncFormikValues?.(combined);

   
    handleShowDetailView(combined);
    window.scrollTo(0, 0);
   
  }, [stepOneValues, stepTwoValues, stepThreeValues, stepFourValues, handleQuickSubmit, handleShowDetailView, syncFormikValues]);


  const isSaveEnabled = useMemo(() => (
    stepOneValid && stepTwoValid && stepThreeValid && (hideStepFour || stepFourValid)
  ), [stepOneValid, stepTwoValid, stepThreeValid, stepFourValid, hideStepFour]);

  const draftValues = useMemo(() => ({
    step2: stepTwoValues,
    step1: stepOneValues,
    step3: stepThreeValues,
    step4: stepFourValues
  }), [stepTwoValues, stepOneValues, stepThreeValues]);

  const riderDetailsContent = useMemo(() => {
    if (!riderDetails) return null;
    return (
      <div className={styles.riderDetails}>
        <h3>Rider Information</h3>
        <p className={styles.riderDetailItem}>
          <span className={styles.riderDetailLabel}>Name: </span>
          {riderDetails.firstName} {riderDetails.lastName}
        </p>
        <p className={styles.riderDetailItem}>
          <span className={styles.riderDetailLabel}>Email: </span> {riderDetails.email}
        </p>
        <p className={styles.riderDetailItem}>
          <span className={styles.riderDetailLabel}>Phone: </span> {riderDetails.phoneNumber}
        </p>
        <p className={styles.riderDetailItem}>
          <span className={styles.riderDetailLabel}>DOB: </span> {riderDetails.dob}
        </p>
      </div>
    );
  }, [riderDetails]);

  return (
    <div className={styles.container}>
      <div className={styles.step}>
        <StepOne
          {...rest}
           
          showCovidField={showCovidField}
          showSubInformation={false}
          quickSchdule={true}
        setFormikValues={handleStepFormikValues(setStepOneValues, 'stepOne')}
          setStepValid={(isValid) => handleStepValid('stepOne', isValid)}
        />

        {/* {riderDetailsContent} */}

        <StepTwo
          {...rest}
              draft={draftValues}
          rideOptions={rideOptions}
          platformPreferences={platformPreferences}
          setFormikValues={handleStepFormikValues(setStepTwoValues, 'stepTwo')}
          showSubInformation={false}
          quickSchdule={true}
          setStepValid={(isValid) => handleStepValid('stepTwo', isValid)}
        />

 

        <StepThree
          {...rest}
          draft={draftValues}
          platformPreferences={platformPreferences}
          defaultTimeZone={defaultTimeZone}
          setFormikValues={handleStepFormikValues(setStepThreeValues, 'stepThree')}
          showSubInformation={false}
          quickSchdule={true}
          setStepValid={(isValid) => handleStepValid('stepThree', isValid)}
        />

        {!hideStepFour && (
          <StepFour
            {...rest}
                draft={draftValues}
            showSubInformation={false}
            costCenterField={costCenterField}
            showAdditionalSourceField={showAdditionalSourceField}
            showDocumentReasonForRideField={showDocumentReasonForRideField}
            setFormikValues={handleStepFormikValues(setStepFourValues, 'stepFour')}
            quickSchdule={true}
            setStepValid={(isValid) => handleStepValid('stepFour', isValid)}
          />
        )}
      </div>

      <div className={styles.btns}>
        <Button
          myClassName={styles.formButton}
          type="submit"
          disabled={!isSaveEnabled}
          onClick={save}
        >
         Confirm
        </Button>

        <Button
          myClassName={styles.linkButton}
          type="button"
          onClick={swtichToDetailView}
        >
          Advanced View
        </Button>
      </div>
    </div>
  );
};

export default React.memo(QuickSchedule);
